export default (theme) => ({
    button: {
        color: theme.palette?.colors.lightCerulean + ' !important',
        padding: '5px 15px !important'
    },
    photoHeading: {
        textTransform: 'uppercase',
        color: theme.palette?.colors.lightCerulean
    },
    imgContainer: {
        width: 240,
        height: 240,
        border: '2px solid var(--grey-100)',
        margin: '20px auto',
        objectFit: 'contain'
    }
});